module.exports = __webpack_public_path__ + "media/dashboard/components/Accordion/icons/info-414eb5bf36bfdfbc50a4858eb2ebb85d.svg";